export default __webpack_public_path__ + "static/Sketch7-037bdaf7c49a5031df518ba78744727f.jpg";